'use client';

import { memo } from 'react';
import Toast from '~/components/customComponents/toast/Toast';
import {
  ADDRESS_UPDATED,
  CART_PDP_PRICE_CALCULATION_UNAVAILABLE,
  CHANGES_SAVED,
  COPIED_TO_CLIPBOARD,
  ERROR_DOWNLOADING_INVOICE,
  ERROR_HAS_HAPPENED,
  ERROR_OCCURRED_WHILE_UPDATING,
  ITEM_CAN_NOT_MERGE,
  ITEM_DELIVERY_DATE_HAS_CHANGED,
  ITEM_HAS_BEEN_ADDED_TO_CART,
  ITEM_HAS_BEEN_MERGED,
  ITEM_HAS_BEEN_REMOVED,
  ITEM_QUANTITY_HAS_CHANGED,
  OTP_SENDING_ERROR,
  OTP_SENT,
  PASSWORD_CHANGE_SUCCESS,
  PASSWORD_CREATE_SUCCESS,
  REQUEST_HAS_BEEN_SENT,
  REQUEST_SENT_TO_ACCOUNT_EXECUTIVE,
} from '~/constants/queryParams';
import { useI18n } from '~/locales/client';
import { ToastTypeEnum } from '~/types-and-enums/toastTypes';

/**
 * Display's Changes saved toast and/or please try again toast
 */
const DisplayToasts = memo(() => {
  const translate = useI18n();
  return (
    <>
      <Toast
        headerText={translate('general.changes-saved')}
        type={ToastTypeEnum.Success}
        toastOpenSearchParam={CHANGES_SAVED}
        duration={2000}
      />
      <Toast
        headerText={translate('general.address-updated')}
        type={ToastTypeEnum.Success}
        toastOpenSearchParam={ADDRESS_UPDATED}
        duration={2000}
      />
      <Toast
        headerText={translate('page.shop.quantity-has-changed')}
        type={ToastTypeEnum.Success}
        toastOpenSearchParam={ITEM_QUANTITY_HAS_CHANGED}
        duration={2000}
      />
      <Toast
        headerText={translate('page.shop.delivery-date-has-changed')}
        type={ToastTypeEnum.Success}
        toastOpenSearchParam={ITEM_DELIVERY_DATE_HAS_CHANGED}
        duration={2000}
      />
      <Toast
        headerText={translate('page.shop.item-removed-successfully')}
        type={ToastTypeEnum.Success}
        toastOpenSearchParam={ITEM_HAS_BEEN_REMOVED}
        duration={2000}
      />
      <Toast
        headerText={translate('page.cart.items-added-to-cart')}
        type={ToastTypeEnum.Success}
        toastOpenSearchParam={ITEM_HAS_BEEN_ADDED_TO_CART}
        duration={2000}
      />
      <Toast
        headerText={translate('page.cart.item-has-been-merged')}
        type={ToastTypeEnum.Success}
        toastOpenSearchParam={ITEM_HAS_BEEN_MERGED}
        duration={2000}
      />

      <Toast
        headerText={translate('page.quotes.request.view.finish.modal.title')}
        type={ToastTypeEnum.Success}
        toastOpenSearchParam={REQUEST_HAS_BEEN_SENT}
        duration={3000}
      />
      <Toast
        headerText={translate('general.request-sent-has-been-sent-to-account-executive')}
        type={ToastTypeEnum.Success}
        toastOpenSearchParam={REQUEST_SENT_TO_ACCOUNT_EXECUTIVE}
        duration={3000}
      />
      <Toast
        headerText={translate('general.password-changed')}
        type={ToastTypeEnum.Success}
        toastOpenSearchParam={PASSWORD_CHANGE_SUCCESS}
        duration={3000}
      />
      <Toast
        headerText={translate('general.password-created')}
        type={ToastTypeEnum.Success}
        toastOpenSearchParam={PASSWORD_CREATE_SUCCESS}
        duration={3000}
      />
      <Toast
        headerText={translate('page.cart.item-can-not-merge')}
        type={ToastTypeEnum.Error}
        toastOpenSearchParam={ITEM_CAN_NOT_MERGE}
        duration={5000}
      />
      <Toast type={ToastTypeEnum.Error} toastOpenSearchParam="errorText" duration={1500} />
      <Toast
        headerText={translate('component.password-matcher.view.submission.failure.description')}
        type={ToastTypeEnum.Error}
        toastOpenSearchParam={ERROR_HAS_HAPPENED}
        duration={3000}
      />
      <Toast
        headerText={translate('page.offers.something-went-wrong-while-updating')}
        type={ToastTypeEnum.Error}
        toastOpenSearchParam={ERROR_OCCURRED_WHILE_UPDATING}
        duration={2000}
      />
      <Toast
        headerText={translate('general.error-occurred-while-downloading-invoice')}
        type={ToastTypeEnum.Error}
        toastOpenSearchParam={ERROR_DOWNLOADING_INVOICE}
        duration={2000}
      />
      <Toast
        headerText={translate('general.price-calculation-unavailable')}
        type={ToastTypeEnum.Error}
        toastOpenSearchParam={CART_PDP_PRICE_CALCULATION_UNAVAILABLE}
        duration={3000}
      />
      <Toast
        headerText={translate('general.copied-to-clipboard')}
        type={ToastTypeEnum.Success}
        toastOpenSearchParam={COPIED_TO_CLIPBOARD}
        duration={2000}
      />
      <Toast
        headerText={translate('page.offers.error-occurred-while-sending-otp')}
        type={ToastTypeEnum.Error}
        toastOpenSearchParam={OTP_SENDING_ERROR}
        duration={3000}
      />
      <Toast
        headerText={translate('general.otp-sent')}
        type={ToastTypeEnum.Success}
        toastOpenSearchParam={OTP_SENT}
        duration={2000}
      />
    </>
  );
});

DisplayToasts.displayName = 'DisplayToasts';

export default DisplayToasts;
